import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource/plus-jakarta-sans/400.css'
import '@fontsource/plus-jakarta-sans/500.css'
import '@fontsource/plus-jakarta-sans/600.css'
import '@fontsource/plus-jakarta-sans/700.css'
import { PublicIrApp } from './PublicIrApp'
import { Provider } from '@/components/ui/provider'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Public IR application root element was not found.')
}

createRoot(rootElement).render(
  <StrictMode>
    <Provider>
      <PublicIrApp />
    </Provider>
  </StrictMode>
)
